import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { createMarkup, stripHtml } from "../../helpers/utils";
import ImageLoader from "../../components/ImageLoader";

const CommonBlock = ({
    spaceTopClass,
    spaceBottomClass,
    imageUrl,
    externalUrl,
    target,
    title,
    subtitle,
    description,
    buttonText,
    imagePosition = "left",
}) => {
    const external_url =
        !(externalUrl + "").startsWith("http") && externalUrl
            ? process.env.PUBLIC_URL + externalUrl
            : externalUrl;
    return (
        <div className={clsx("funfact-area", spaceTopClass, spaceBottomClass)}>
            <div className="container">
                <div className="row align-items-center">
                    <div
                        className={`col-md-${imageUrl ? 8 : 12} col-lg-${
                            imageUrl ? 6 : 12
                        } order-1 order-lg-${imagePosition === "left" ? 2 : 1}`}
                    >
                        <div className="funfact-content funfact-res">
                            {!!title && (
                                <h1
                                    style={{ fontWeight: "bold" }}
                                    dangerouslySetInnerHTML={{ __html: title }}
                                ></h1>
                            )}
                            {!!subtitle && (
                                <h3
                                    style={{ fontWeight: "bold" }}
                                    dangerouslySetInnerHTML={{
                                        __html: subtitle,
                                    }}
                                ></h3>
                            )}
                            {!!description && (
                                <div
                                    style={{ fontSize: 16 }}
                                    dangerouslySetInnerHTML={createMarkup(
                                        description,
                                        [
                                            {
                                                tag: "p",
                                                style: { marginBottom: 0 },
                                            },
                                        ]
                                    )}
                                ></div>
                            )}

                            {!!buttonText && (
                                <div className="funfact-btn  funfact-btn-main btn-hover">
                                    {external_url ? (
                                        <Link to={external_url} target={target}>
                                            {buttonText}
                                        </Link>
                                    ) : (
                                        <a href="#" onClick={(e) => e.preventDefault()} style={{cursor:'default', pointerEvents:'none'}}>
                                            {buttonText}
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                    {!!imageUrl && (
                        <div
                            className={`col-md-4 col-lg-6 order-2 order-lg-${
                                imagePosition === "left" ? 1 : 2
                            }`}
                        >
                            <div className="funfact-image">
                                {externalUrl ? (
                                    <Link to={external_url}>
                                        <ImageLoader
                                            src={imageUrl}
                                            alt={title}
                                            className="img-fluid"
                                            height={500}
                                        />
                                    </Link>
                                ) : (
                                    <ImageLoader
                                        src={imageUrl}
                                        alt={title}
                                        className="img-fluid"
                                        height={500}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

CommonBlock.propTypes = {
    spaceBottomClass: PropTypes.string,
    spaceTopClass: PropTypes.string,
    imageUrl: PropTypes.string,
    imagePosition: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    buttonText: PropTypes.string,
    externalUrl: PropTypes.string,
};

export default CommonBlock;
